module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "middle-white-box"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "not-found-img",
    attrs: {
      "src": _vm.imageNotFound
    }
  }), _c('br'), _c('p', {
    staticClass: "big-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('naoEncontrado.labels.mensagem'))
    }
  }), _c('button-primary', {
    attrs: {
      "label": _vm.$t('naoEncontrado.labels.voltarHome'),
      "faIcon": "",
      "clickFunction": _vm.goHome,
      "id": "btn404VoltarParaHome",
      "customClass": "big-primary"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73ba95ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ba95ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/notFound/notFound.pug
// module id = 1436
// module chunks = 0